import React from 'react'
import Layout from './layout'

const BadRequestPage = () => {
  return (
    <Layout>
      <div className="max-w-1200 mx-auto px-5 lg:px-0">
        <h1 className="pt-10 text-center font-bold text-2xl">404 not found</h1>
        <p></p>
      </div>
    </Layout>
  )
}

export default BadRequestPage
